import { useRootStore } from '@qsrsoft/myq-core';
import { useCalendarStore } from '@/views/dashboard/widgets/calendar/store';

export const calendarRoute = {
  path: '/calendar',
  name: 'Calendar',
  meta: { hidePageHeader: true },
  component: () =>
    import('@/views/dashboard/widgets/calendar/ui/calendar_view.vue'),
  async beforeEnter(_to, _from, next) {
    await useRootStore().waitForUserToBeLoaded();
    if (!useCalendarStore().calendarVisible) {
      return next('/');
    }
    next();
  },
};
